

// authSlice.jsx
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import authService from "./authService";

// const user = localStorage.getItem("user");
const user = JSON.parse(localStorage.getItem("user")) || null;


const initialState = {
	user: user ? user : null,
	isErrorAuth: false,
	isLoading: false,
	isSuccessAuth: false,
	message: "",
};

export const register = createAsyncThunk(
	"auth/register",
	async (user, thunkAPI) => {
		try {
			return await authService.register(user);
		} catch (error) {
			const message =
				(error.response &&
					error.response.data &&
					error.response.data.message) ||error.message ||error.toString();

			return thunkAPI.rejectWithValue(message);
		}
	}
);

export const login = createAsyncThunk("auth/login", async (user, thunkAPI) => {
	try {
		return await authService.login(user);
	} catch (error) {
		const message =
			(error.response &&
				error.response.data &&
				error.response.data.message) ||
			error.message ||
			error.toString();

		return thunkAPI.rejectWithValue(message);
	}
});

export const logout = createAsyncThunk("auth/logout", async () => {
	authService.logout();
});

export const activate = createAsyncThunk(
	"auth/activate",
	async (user, thunkAPI) => {
		try {
			return await authService.activate(user);
		} catch (error) {
			const message =
				(error.response &&
					error.response.data &&
					error.response.data.message) ||
				error.message ||
				error.toString();

			return thunkAPI.rejectWithValue(message);
		}
	}
);

export const authSlice = createSlice({
	name: "auth",
	initialState,
	reducers: {
		reset: (state) => {
			state.isLoading = false;
			state.isErrorAuth = false;
			state.isSuccessAuth = false;
			state.message = "";
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(register.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(register.fulfilled, (state, action) => {
				state.isLoading = false;
				state.isSuccessAuth = true;
				state.user = action.payload;
			})
			.addCase(register.rejected, (state, action) => {
				state.isLoading = false;
				state.isErrorAuth = true;
				state.message = action.payload;
				state.user = null;
			})
			.addCase(login.pending, (state) => {
				state.isLoading = true;
				state.isErrorAuth = false;
				state.message = "";

			})
			.addCase(login.fulfilled, (state, action) => {
				state.isLoading = false;
				state.isSuccessAuth = true;
				state.user = action.payload;
				state.isErrorAuth = false;
				state.message = action.payload;
			})
			.addCase(login.rejected, (state, action) => {
				state.isLoading = false;
				// state.isErrorAuth = true;
				state.message = action.payload;
				state.user = null;
				// reset the state
				state.isErrorAuth = false;
				state.isSuccessAuth = false;

				// Clear local storage
				localStorage.removeItem("user");

			})
			.addCase(logout.fulfilled, (state) => {
				state.user = null;
				state.isSuccessAuth = false;
				// state.isErrorAuth = false;
			})
			.addCase(activate.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(activate.fulfilled, (state, action) => {
				state.isLoading = false;
				state.isSuccessAuth = true;
			})
			.addCase(activate.rejected, (state, action) => {
				state.isLoading = false;
				state.isErrorAuth = true;
				state.message = action.payload;
				state.user = null;
			});
	},
});

export const { reset } = authSlice.actions;

export default authSlice.reducer;